// External library import
import * as yup from 'yup';
import { ERRORS } from '../../utils/validationHelper';
import _ from 'lodash';

export const EdgeDevice = yup.object().shape({
    edgeAlias: yup.string().required(),
    systemId: yup.string().required(),
    disabled: yup.boolean().required(),
    licenseId: yup.string().optional(),
    groupId: yup.string().when('licenseId', {
        is: undefined,
        then: yup.string().optional(),
        otherwise: yup.string().required(ERRORS.required),
    }),
    market: yup.array().when('groupId', {
        is: undefined,
        then: yup.array().optional(),
        otherwise: yup.array().required(),
    }),
    defaultMarket: yup.string().when('groupId', {
        is: undefined,
        then: yup.string().optional(),
        otherwise: yup.string().required(),
    }),
    properties: yup.object().shape({
        signalId: yup.string().test('SignalId', ERRORS.required, (value, c) => {
            let isGroupId = c?.from?.[1]?.value?.groupId;
            if (isGroupId) {
                if (value !== undefined) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }),
        frequency: yup.object().optional(),
        edgeConfiguration: yup.mixed().optional(),
        edgeConfigurationHistory: yup.array().optional(),
        profile: yup
            .object()
            .shape({
                basePower: yup.boolean().optional(),
            })
            .optional(),
        maxDuration: yup.number().required(ERRORS.required),
        startDelay: yup.number().required(ERRORS.required),
        codeVersion: yup.string().optional(),
        notes: yup.string().optional(),
    }),
});

export const forceFactorValidation = (markets = []) => {
    const validationSchema = {};
    markets.map((m) => {
        _.set(
            validationSchema,
            m,
            yup.object().shape({
                status: yup.string().required(ERRORS.required),
                value: yup.number().when('status', {
                    is: 'CUSTOM',
                    then: yup.number().required(ERRORS.required),
                    otherwise: yup.number().optional(),
                }),
                adjustmentFactor: yup.number().when('status', {
                    is: 'CUSTOM',
                    then: yup.number().required(ERRORS.required),
                    otherwise: yup.number().optional(),
                }),
            })
        );
    });

    return yup.object().shape(validationSchema);
};
